import Axios from 'axios'
import store from './store'

import { getCookie } from './cookiesHandler'

Axios.defaults.baseURL = process.env.VUE_APP_ROOT_API

// if ( getCookie('_ad02f725-a21b-4c57-910f-d1fea983ea00') ) {
//   Axios.defaults.headers.common['Authorization'] = `Bearer ${ getCookie('_ad02f725-a21b-4c57-910f-d1fea983ea00') }`
// }

let excludeUrls = [
  'payment/make',
  'library',
  'upload',
  'payment/multi/make',
  'course/quick/buy',
  'teacher/report',
  'course/leason/doubts'
]

let iuguScript = document.createElement('script')
iuguScript.setAttribute('src', 'https://js.iugu.com/v2')
document.head.appendChild(iuguScript)

function checkUrlIncludes(url) {
  for(let i = 0; i < excludeUrls.length; i++) {
    if (url.includes(excludeUrls[i])) return true
  }
  return false
}

function showLoading ( config ) {
  if (config.onUploadProgress) return false
  if (checkUrlIncludes(config.url)) return false
  return true
}

Axios.interceptors.request.use((config) => {
  if(showLoading(config)) {
    store.commit('TOGGLE_LOADING', true)
  }

  if(!config.url.includes("https://api.vimeo.com/") ) {
    const token = getCookie('_ad02f725-a21b-4c57-910f-d1fea983ea00');
    config.headers.Authorization = `Bearer ${ token }`;
  }

  return config;
}, (error) => {
  store.commit('TOGGLE_LOADING', false)
  return Promise.reject(error);
});

Axios.interceptors.response.use(
  response => {
    store.commit('TOGGLE_LOADING', false)
    return response;
  },
  error => {
    store.commit('TOGGLE_LOADING', false)
    if (error.response && error.response.status === 401) {
      router.push('/login')
    }
    return Promise.reject(error);
  }
);
